import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    Button: {
      'margin-bottom': 15,
      'margin-top': 15
    },

}));

function ButtonDeleteChart({deletChart,projectId,chartId}) {
    const [openDelete, setOpenDelete] = React.useState(false);
    const classes = useStyles();

    const clickDelete = event => {
        setOpenDelete(false)
        deletChart(projectId, chartId);

    };


  return (
    <>
      <Button
        className={classes.Button}
        onClick={() => setOpenDelete(true)}
        variant="contained"
        color="secondary">
          Delete
      </Button>

      <Modal
          aria-labelledby="update-modal-title"
          aria-describedby="update-modal-description"
          className={classes.modal}
          open={openDelete}
          onClose={() => setOpenDelete(false)}
      >
        <Slide direction="up" in={openDelete} mountOnEnter unmountOnExit>
          <div className={classes.paper}>
            <h2> Are you shure? </h2>
            <Button
              className={classes.Button}
              onClick={() => clickDelete()}
              variant="contained"
              color="secondary">
                Yes, Delete it
            </Button>
          </div>
        </Slide>
      </Modal>
    </>


  )
}

const mapStateToProps = state => state.charts;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(ButtonDeleteChart)
